import { render, staticRenderFns } from "./AnswerTypeSubsection.vue?vue&type=template&id=6a41b9db"
import script from "./AnswerTypeSubsection.vue?vue&type=script&lang=js"
export * from "./AnswerTypeSubsection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports